<style lang="scss">
  @use "../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(32px);
  }
</style>

<script>
  import { integrationStore } from "../../stores";
  import AdvancedSettingsSection from "./components/AdvancedSettingsSection.svelte";
  import CompanySettings from "./components/CompanySettings.svelte";
  import DescriptionSection from "./components/DescriptionSection.svelte";
  import FlaggedSettings from "./components/FlaggedSettings.svelte";
  import JobSettings from "./components/JobSettings.svelte";
  import { dropdownKeys, jobStatusKey, toggleKeys } from "./utils";

  $: allGeneralSettings = $integrationStore.getSettings("general");

  $: dropdownSettings = dropdownKeys
    .map((key) =>
      allGeneralSettings.find(
        (setting) => setting.key === key && setting.kind === "singleChoice"
      )
    )
    .filter(Boolean);

  $: toggleSettings = toggleKeys
    .map((key) =>
      allGeneralSettings.find(
        (setting) => setting.key === key && setting.kind === "checkbox"
      )
    )
    .filter(Boolean);

  $: jobStatusSetting = $integrationStore
    .getSettings("general")
    .find((setting) => setting.key === jobStatusKey);
</script>

<div class="tab-body">
  <DescriptionSection />
  <div class="container">
    <CompanySettings {dropdownSettings} />
    <JobSettings {jobStatusSetting} />
    <FlaggedSettings {toggleSettings} />
  </div>
  <AdvancedSettingsSection />
</div>
